import React, { forwardRef, useEffect, useRef, useState } from 'react';
import { ResponsiblePersonDataGrid } from '../../../components/datagrid/ResponsiblePersonDatagrid';
import { Loader } from '../../../components/loader/Loader';
import { useBreadcrumbs } from '../../../contexts/breadcrumbsContext';
import { useTranslation } from '../../../contexts/translation';
import AssetResponsiblePersonReportFilter from '../../../forms/filter/assetResponsiblePersonReport/AssetResponsiblePersonReportFilter';
import { useSaveDataGridFilter } from '../../../hooks/useSaveDataGridFilter';
import { PageContentWrapper } from '../../../layouts/contentWrapper/PageContentWrapper';
import { ResponsiblePersonReportType } from '../../../types/responsiblePersonReport.types';
import { ReportType } from '../../../utils/reportTypeKeys';
import '../Reports.scss';

export function ResponsiblePersonReport() {
  const [data, setData] = useState<Array<ResponsiblePersonReportType> | null>([]);
  const [isFilterVisible, setFilterVisible] = useState<boolean>(true);
  const [selectedFilter, setSelectedFilter] = useState<string | null>(null);
  const { translate } = useTranslation();
  const transFormName = 'ResponsiblePersonReport';
  const dataGridRef = useRef<any>();
  const { setValue } = useBreadcrumbs();
  // Indikátor, zda se má provést reset filtru DataGridu i filtru mimo DataGrid
  const [resetFilterAction, setResetFilterAction] = useState<boolean>(false);
  const [isDatagridFilterActive, setIsDatagridFilterActive] = useState<boolean>(false);

  const reportType = ReportType.AssetResponsiblePerson;
  const {
    getActualJsonState,
    loadFilter,
    resetFilter,
    saveFilter,
    data: datagridJsonData,
  } = useSaveDataGridFilter(reportType.key, dataGridRef);

  useEffect(() => {
    setValue({
      pageName: 'Responsible person report',
      steps: [{ name: 'Home', pathToCutCount: 1 }],
    });
    return () => {
      setValue(null);
    };
  }, []);

  useEffect(() => {
    if (resetFilterAction) {
      resetFilter();
      setResetFilterAction(false);
    }
    saveFilter();

    if (!dataGridRef.current || !dataGridRef.current.instance) return;
  }, [resetFilterAction]);

  if (!data) return <Loader />;

  return (
    <PageContentWrapper
      heading={isFilterVisible ? translate!('Responsible person report', transFormName) : ''}
    >
      <>
        <AssetResponsiblePersonReportFilter
          dataGridRef={dataGridRef}
          onDataChange={setData}
          onFilterChange={setSelectedFilter}
          report={ReportType.AssetResponsiblePerson}
          filterVisibility={isFilterVisible}
        />
        {isDatagridFilterActive && (
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}>
            <span className="datagrid-active-filter">
              {translate!('You have active filter', 'Reports.Bar')}
            </span>
          </div>
        )}
        <ResponsiblePersonDataGrid
          data={data}
          dataGridRef={dataGridRef}
          heading={`${translate!('Responsible person report', transFormName)}${
            selectedFilter ? ` - ${selectedFilter}` : ''
          }`}
          filterVisibility={isFilterVisible}
          setFilterVisibility={setFilterVisible}
          resetFilter={() => setResetFilterAction(true)}
          filterChanged={(hasFilter) => {
            setIsDatagridFilterActive(hasFilter);
          }}
          noTopPadding={isDatagridFilterActive}
        />
      </>
    </PageContentWrapper>
  );
}
export default forwardRef(ResponsiblePersonReport);
